import React from "react";
import { Link } from "react-router-dom";
import ProjectsData from "../data/projects";

const Projects = () => {
  return (
    <section id="projects" className="text-gray-600 body-font bg-whitesmoke py-16">
      <div className="container px-5 mx-auto">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="sm:text-4xl text-3xl font-bold title-font mb-3 text-gray-900">
            Projects
          </h1>
          <div className="h-1 w-20 bg-dark-orange rounded-full mx-auto mb-4"></div>
          <p className="text-lg font-medium leading-relaxed text-dark-orange">
            What I've Built
          </p>
        </div>

        {/* The Clean Container */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
          <div className="flex flex-wrap -m-4 justify-center">
            {ProjectsData.map((project) => {
              
              // FIX: Ensure icons render correctly from the array
              const MainIcon = project.icons && project.icons.length > 0 ? project.icons[0] : null;

              return (
                <div key={project.id} className="p-4 w-full sm:w-1/2 lg:w-1/3">
                  <Link to={`/project/${project.id}`} className="group">
                    <div className="h-full flex flex-col items-center text-center p-8 rounded-2xl border border-gray-100 bg-gray-50 group-hover:bg-white group-hover:shadow-2xl group-hover:border-dark-orange group-hover:-translate-y-2 transition-all duration-300 cursor-pointer">
                      
                      {/* Technical Icon Container */}
                      <div className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-white text-darkblue mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300">
                        {MainIcon && <MainIcon className="text-4xl" />}
                      </div>
                      
                      <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-dark-orange transition-colors">
                        {project.name}
                      </h2>
                      
                      <p className="leading-relaxed text-sm text-gray-600 mb-6">
                        {project.shortDesc}
                      </p>
                      
                      <div className="mt-auto text-dark-orange inline-flex items-center font-bold text-sm uppercase tracking-widest">
                        Explore Technical Details
                        <svg className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M5 12h14"></path>
                          <path d="M12 5l7 7-7 7"></path>
                        </svg>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;